import { createFileRoute } from '@tanstack/react-router'
import { AssistantSwitch } from '../../../../components/assistant-switch'
import { InvestorHomeRedirect } from '../../../../components/investor-home-redirect'
import { InvestorFeedPage } from '../../../../features/legacy-investor/feed-page'

// Feed is gone; this address stays for links already sent.
export const Route = createFileRoute('/app/investor/$id/feed')({
  component: () => (
    <AssistantSwitch assistant={<InvestorHomeRedirect />} classic={<InvestorFeedPage />} />
  ),
})
